<template>
  <div :class="$style.login" @touchmove.prevent>
    <div :class="$style.mask"></div>
    <div :class="$style.context">
      <div :class="$style.bindAccount">
        <p :class="$style.notice">账号登录</p>
        <div :class="$style.formItem">
          <span :class="`${$style.label} ${!active && $style.active}`"
            >账号</span
          >
          <Field
            v-model.trim="username"
            :class="`${$style.value} ${!active && $style.active}`"
            @focus="handleBlur(0)"
          >
            <template v-slot:right-icon>
              <i class="iconfont yw-guanbi1" @click="username = ''"></i>
            </template>
          </Field>
        </div>
        <div :class="$style.formItem">
          <span :class="`${$style.label} ${active && $style.active}`"
            >密码</span
          >
          <Field
            v-model.trim="password"
            :class="`${$style.value} ${active && $style.active}`"
            :type="pwdShowType"
            @focus="handleBlur(1)"
          >
            <template v-slot:right-icon>
              <i
                class="iconfont yw-chakan"
                @click="
                  pwdShowType = pwdShowType === 'password' ? '' : 'password'
                "
              ></i>
            </template>
          </Field>
        </div>
        <p :class="$style.forget" @click="$emit('forget')">忘记密码</p>
        <Button type="info" :class="$style.submit" @click="submit">登录</Button>
      </div>
      <i class="iconfont yw-close" @click="close"></i>
    </div>
  </div>
</template>

<script>
import { Field, Button, Toast } from "vant";
import { mapActions } from "vuex";
import CryptoJS from "crypto-js";

export default {
  name: "",
  data() {
    return {
      username: "",
      password: "",
      active: "",
      pwdShowType: "password",
    };
  },
  methods: {
    ...mapActions({
      login: "recall/login",
    }),
    async submit() {
      const reg = new RegExp(/^[a-zA-Z0-9]{6,36}$/);
      if (!reg.test(this.username)) {
        Toast.fail("账号有误，请检查后重新填写~");
        return;
      }
      if (!this.password) {
        Toast.fail("请输入密码~");
        return;
      }
      await this.login({
        user_name: this.username,
        password: CryptoJS.MD5(
          this.password + CryptoJS.MD5(this.password)
        ).toString(),
      });
      Toast("登录成功");
      this.$emit("close");
      this.$emit("freshTemp");
    },
    close() {
      this.$emit("close");
    },
    handleBlur(e) {
      this.active = e;
    },
    setAccount(phone) {
      this.username = phone;
    },
  },
  components: {
    Field,
    Button,
  },
};
</script>

<style lang="scss" module>
@mixin border-bottom-1px($left: 0, $width: 100%) {
  position: relative;
  &:before {
    display: block;
    position: absolute;
    left: $left;
    bottom: 1px;
    width: $width;
    border-top: 1px solid #ececec;
    content: " ";
    z-index: 1;
  }
}

.login {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.65);
  }
  .context {
    position: absolute;
    width: 351px;
    height: 340px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    .bindAccount {
      width: 351px;
      height: 271px;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 30px;
      .notice {
        color: #9d9d9d;
        text-align: center;
        font-size: 15px;
        line-height: 18px;
        margin-bottom: 30px;
      }
      .formItem {
        display: flex;
        align-items: center;
        width: 90%;
        margin: auto;
        :global {
          .yw-chakan,
          .yw-guanbi1 {
            font-size: 13px;
            width: 18px;
            display: inline-block;
            text-align: center;
          }
        }
        .label {
          flex: none;
          color: #9d9d9d;
          margin-right: 20px;
          display: inline-block;
          &.active {
            color: #33bdfe;
          }
        }
        .value {
          padding: 5px 10px;
          @include border-bottom-1px;
          &.active {
            &::before {
              border-color: #33bdfe;
            }
          }
        }
        .verifyCode {
          height: 20px;
          line-height: 20px;
          border-radius: 20px;
          border-color: #33bdfe;
          font-size: 12px;
          padding: 0 10px;
        }
      }
      .forget {
        text-align: right;
        padding-right: 16px;
        margin-top: 10px;
        font-size: 12px;
      }
      .submit {
        width: 247px;
        border-radius: 22px;
        background: linear-gradient(
          -90deg,
          rgba(36, 180, 254, 1),
          rgba(82, 208, 255, 1)
        );
        border: none;
        display: block;
        margin: auto;
        margin-top: 12px;
      }
    }
    :global {
      .yw-close {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        color: #ffffff;
        font-size: 50px;
        z-index: 1;
        margin: auto;
        font-weight: 100;
      }
    }
  }
}
</style>